export enum Cy_RezaUi {
  detailHeading = 'reza-ui-detail-heading',
}
